import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-card-titulo-etapa',
  templateUrl: './card-titulo-etapa.component.html',
  styleUrl: './card-titulo-etapa.component.scss'
})
export class CardTituloEtapaComponent {
  @Input() titulo: string = '';
  @Input() descricao: string = '';
  @Input() tipoSucesso: boolean = false;
}
